import { trackEvent } from '.';

enum ClickstreamTriggerLocation {
  RENT_REPORTING_ONBOARDING = 'rent_reporting_onboarding',
  RENT_REPORTING_DASHBOARD = 'rent_reporting_dashboard',
}

enum ClickstreamTriggerType {
  VIEW = 'view',
  INTERACTION = 'interaction',
}

export enum ClickstreamTriggerObject {
  NO_TRIGGER_OBJECT = 'no_trigger_object',
  ZRM_MODAL = 'zrm_modal',
  ZRM_UPSELL = 'zrm_upsell',
  FAQ_UPSELL = 'faq_upsell',
  WIZARD_UPSELL = 'wizard_upsell',
}

export enum ClickstreamTriggerObjectOnboardingScreen {
  START_PAGE = 'start_page',
  HOW_IT_WORKS = 'how_it_works',
  NAME_ENTRY = 'name_entry',
  IDENTITY_VERIFICATION = 'identity_verification',
  LEASE_ADDRESS = 'lease_address',
  PHONE_NUMBER = 'phone_number',
  LEASE_DETAILS = 'lease_details',
  ACCOUNT_LINK = 'account_link',
  PAYMENT_IDENTIFICATION = 'payment_identification',
  ORDER_SUMMARY = 'order_summary',
  PAYMENT_PROCESSING = 'payment_processing',
  SUCCESS_CONFIRMATION = 'success_confirmation',
}

export enum ClickstreamAuthTriggerSource {
  ESUSU_ENROLLMENT = 'esusu_enrollment',
  ESUSU_DASHBOARD = 'esusu_dashboard',
  ZRM_REQUEST_FAQ = 'zrm_request_faq',
  ZRM_REQUEST_UPSELL = 'zrm_request_upsell',
}

export const emitOnboardingWizardViewEvent = () => {
  trackEvent({
    envelope: {
      event_type_id: '8519',
      event_type_version_id: '1',
      event_template_id: '171',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: ClickstreamTriggerType.VIEW,
      trigger_location_nm: ClickstreamTriggerLocation.RENT_REPORTING_ONBOARDING,
      trigger_source_nm: 'rent_reporting_onboarding',
      trigger_object_nm: ClickstreamTriggerObject.NO_TRIGGER_OBJECT,
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: ['rent_reporting'],
    },
  });
};

export const emitOnboardingWizardNextEvent = (clickstreamTriggerObject: ClickstreamTriggerObjectOnboardingScreen) => {
  trackEvent({
    envelope: {
      event_type_id: '8520',
      event_type_version_id: '1',
      event_template_id: '171',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: ClickstreamTriggerType.INTERACTION,
      trigger_location_nm: ClickstreamTriggerLocation.RENT_REPORTING_ONBOARDING,
      trigger_source_nm: 'next',
      trigger_object_nm: clickstreamTriggerObject,
    },
    semantic: {
      semantic_event_nm: 'continue_rrfa_onboarding',
      topic_tag_txt: ['rent_reporting'],
    },
  });
};

export const emitExitOnboardingEvent = (stage: ClickstreamTriggerObjectOnboardingScreen) => {
  trackEvent({
    envelope: {
      event_type_id: '8521',
      event_type_version_id: '1',
      event_template_id: '171',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: ClickstreamTriggerType.INTERACTION,
      trigger_location_nm: ClickstreamTriggerLocation.RENT_REPORTING_ONBOARDING,
      trigger_source_nm: 'exit',
      trigger_object_nm: stage,
    },
    semantic: {
      semantic_event_nm: 'exit_rrfa_onboarding',
      topic_tag_txt: ['rent_reporting'],
    },
  });
};

export const emitFaqClickEvent = (faq: string) => {
  trackEvent({
    envelope: {
      event_type_id: '8522',
      event_type_version_id: '1',
      event_template_id: '171',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: ClickstreamTriggerType.INTERACTION,
      trigger_location_nm: ClickstreamTriggerLocation.RENT_REPORTING_ONBOARDING,
      trigger_source_nm: faq,
      trigger_object_nm: 'rent_reporting_for_all',
    },
    semantic: {
      semantic_event_nm: 'learn_more_rrfa',
      topic_tag_txt: ['rent_reporting'],
    },
  });
};

export const emitRequestPaymentsModalOpenEvent = (clickstreamTriggerObject: ClickstreamTriggerObject) => {
  trackEvent({
    envelope: {
      event_type_id: '8548',
      event_type_version_id: '1',
      event_template_id: '171',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: ClickstreamTriggerType.INTERACTION,
      trigger_location_nm: ClickstreamTriggerLocation.RENT_REPORTING_ONBOARDING,
      trigger_source_nm: 'see_zrm_version',
      trigger_object_nm: clickstreamTriggerObject,
    },
    semantic: {
      semantic_event_nm: 'request_zillow_payments_from_faq',
      topic_tag_txt: ['rent_reporting'],
    },
  });
};

export const emitRequestPaymentsSubmitEvent = (clickstreamTriggerObject: ClickstreamTriggerObject) => {
  trackEvent({
    envelope: {
      event_type_id: '8549',
      event_type_version_id: '1',
      event_template_id: '171',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: ClickstreamTriggerType.INTERACTION,
      trigger_location_nm: ClickstreamTriggerLocation.RENT_REPORTING_ONBOARDING,
      trigger_source_nm: 'send_request_to_landlord',
      trigger_object_nm: clickstreamTriggerObject,
    },
    semantic: {
      semantic_event_nm: 'request_zillow_payments',
      topic_tag_txt: ['rent_reporting'],
    },
  });
};

export const emitClickSettingsEvent = () => {
  trackEvent({
    envelope: {
      event_type_id: '8525',
      event_type_version_id: '1',
      event_template_id: '267',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: ClickstreamTriggerType.INTERACTION,
      trigger_location_nm: ClickstreamTriggerLocation.RENT_REPORTING_DASHBOARD,
      trigger_source_nm: 'settings',
      trigger_object_nm: 'rent_reporting_for_all',
    },
    semantic: {
      semantic_event_nm: 'rent_reporting_settings',
      topic_tag_txt: ['rent_reporting'],
    },
  });
};

export const emitContactSupportEvent = () => {
  trackEvent({
    envelope: {
      event_type_id: '8526',
      event_type_version_id: '1',
      event_template_id: '171',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: ClickstreamTriggerType.INTERACTION,
      trigger_location_nm: ClickstreamTriggerLocation.RENT_REPORTING_DASHBOARD,
      trigger_source_nm: 'view_faq',
      trigger_object_nm: 'rent_reporting_for_all',
    },
    semantic: {
      semantic_event_nm: 'access_support',
      topic_tag_txt: ['rent_reporting'],
    },
  });
};

export const emitAuthStartEvent = (triggerSource: ClickstreamAuthTriggerSource) => {
  trackEvent({
    envelope: {
      event_type_id: '8550',
      event_type_version_id: '1',
      event_template_id: '171',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: ClickstreamTriggerType.INTERACTION,
      trigger_location_nm: ClickstreamTriggerLocation.RENT_REPORTING_ONBOARDING,
      trigger_source_nm: triggerSource,
      trigger_object_nm: 'rent_reporting_for_all',
    },
    semantic: {
      semantic_event_nm: 'auth_start',
      topic_tag_txt: ['rent_reporting'],
    },
  });
};

export const emitAuthCompleteEvent = (triggerSource: ClickstreamAuthTriggerSource) => {
  trackEvent({
    envelope: {
      event_type_id: '8551',
      event_type_version_id: '1',
      event_template_id: '171',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: ClickstreamTriggerType.INTERACTION,
      trigger_location_nm: ClickstreamTriggerLocation.RENT_REPORTING_ONBOARDING,
      trigger_source_nm: triggerSource,
      trigger_object_nm: 'rent_reporting_for_all',
    },
    semantic: {
      semantic_event_nm: 'auth_complete',
      topic_tag_txt: ['rent_reporting'],
    },
  });
};
